import { render, staticRenderFns } from "./ErrorFallback.vue?vue&type=template&id=79d5cfd3&"
import script from "./ErrorFallback.vue?vue&type=script&lang=js&"
export * from "./ErrorFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports